import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {ArrowUpRightIcon, type Icon} from '@primer/octicons-react'
import styles from './MiniMergeSections.module.css'
import {MiniMergeStatusItem} from './MiniMergeStatusItem'

export function MiniStatusSkeletonItem({
  text,
  action,
  icon,
}: {
  text?: string
  action?: (returnFocusTo?: HTMLElement | null) => void
  icon?: Icon
}) {
  const actionIcon = action ? (icon ?? ArrowUpRightIcon) : undefined

  return (
    <MiniMergeStatusItem
      aria-label={action ? `View ${text ?? 'details'}` : 'Loading merge status'}
      onClick={action ? event => action(event.currentTarget) : undefined}
    >
      <MiniMergeStatusItem.LabelRow icon={actionIcon}>
        <span className="d-flex flex-items-center gap-1">
          {text ? (
            <MiniMergeStatusItem.Label>{text}</MiniMergeStatusItem.Label>
          ) : (
            <LoadingSkeleton variant="text" width="80px" />
          )}
        </span>
        {!action ? (
          <LoadingSkeleton variant="rounded" width="20px" height="20px" className={styles.MiniStatusLoadingIcon} />
        ) : null}
      </MiniMergeStatusItem.LabelRow>
      <LoadingSkeleton className={styles.MiniStatusProgress} variant="rounded" height="8px" />
    </MiniMergeStatusItem>
  )
}
